module.exports = __webpack_public_path__ + "static/img/zhenyu_icon.d2e237c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/zhenyu_icon.png
// module id = hQvk
// module chunks = 1